import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";

import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import "./anexoII2.scss";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { eliminarPuestos, getPuestosSeleccionados, reodenarPuestos } from "../../components/services/ConcursosService";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";

const PuestosOrdenPreferencia = () => {
  //const location = useLocation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  //const adscripcion = location?.state?.adscripcion;
  const [puestosSeleccionados, setPuestosSeleccionados] = useState();
  const [listaPuestoBorrar, setListaPuestoBorrar] = useState([]);
  const [nuevoOrdenPuestosSeleccionados, setNuevoOrdenPuestosSeleccionados] = useState([]);
  const [bloquearReordeno, setBloquearReordeno] = useState(false);

  const [show, setShow] = useState({
    mensaje: false,
  });

  const params = useParams();
  // 

  const handleListaPuestoBorrar = (isChecked, puesto) => {
    if (isChecked) {
      // Agregar idPuesto al array si el checkbox está seleccionado
      setListaPuestoBorrar((prevLista) => [...prevLista, puesto]);
    } else {
      // Eliminar idPuesto del array si el checkbox no está seleccionado
      setListaPuestoBorrar((prevLista) => prevLista?.filter((item) => item !== puesto));
    }


  }


  let timer = null;
  const columnas = [

    {
      name: "Nuevo Orden",
      selector: (row, rowIndex) => {
        return (<>
          <div className="ordenAct row">
            <div className="col-6">
              <input type="number" name="" id="nuevoOrden" min={1} className="form-control"
                placeholder={rowIndex + 1}


                onChange={(event) => {
                  const orden = event.target.value;
                  if (orden !== "") {
                    clearTimeout(timer); // Reset the timer
                    timer = setTimeout(() => {
                      const newOrden = { xpt: row.xpt, orden: parseInt(orden) };
                      const index = nuevoOrdenPuestosSeleccionados.findIndex((o) => o.xpt === newOrden.xpt);
                      if (index !== -1) {

                        // Actualizamos el objeto existente en el array si el orden es diferente
                        if (nuevoOrdenPuestosSeleccionados[index].orden !== newOrden.orden) {

                          nuevoOrdenPuestosSeleccionados[index].orden = newOrden.orden;
                        }
                      }
                      if (nuevoOrdenPuestosSeleccionados.find((o) => o.orden === newOrden.orden && o.xpt !== newOrden.xpt)) {
                        alert(`Error: El orden ${newOrden.orden} ya existe en la lista`);
                        setBloquearReordeno(true);
                      } else {
                        setBloquearReordeno(false);
                      }
                    }, 500); // Wait 500ms before executing the code
                  }

                }} />
            </div>
          </div>
        </>)
      },

      grow: 2,
      wrap: true,
    },
    {
      name: "Descripción del puesto (Código)",
      selector: (row) => (<>
        <div className="descPuesto">
          <div>{row.xpt} - {row.denominacion} </div>
          <div>{row.xestorg} - {row.destorg}</div>
          <div>{row.dlocalidad}</div>
          <div>{row.lResulta === "N" ? "VACANTE" : "RESULTA"}</div>
        </div>
      </>),

      grow: 2,
      wrap: true,
    },
    {
      name: "Borrar Marcados",
      selector: (row) => (<>
        <div className="ordenAct mx-5">
          <div className="col">
            <input
              type="checkbox"
              name="checkBorrarPuesto"
              id=""
              className="form-check-input"
              onChange={(event) => handleListaPuestoBorrar(event.target.checked, row.xpt)}
            />        </div>
        </div>
      </>),
      style: {
        textAlign: 'center'
      },
      grow: 1,
      wrap: true,
    },
  ];
  //const [puestosElegidos, setPuestosElegidos] = useState([]);



  const handleGetOrder = (e) => {
    for (let i = 0; i < e.selectedRows.length; i++) {
      if (e.selectedRows.length > 0) {
        e.selectedRows[i].preferencia = i + 1;
        e.selectedRows[i].value = i + 1;
      }

    }
  };

  // if (adscripcion === "F") {
  //   ConstantesTabla.columnasTablaSeleccionPuestos.forEach((col) => {
  //     columnas.push(col);
  //   });
  // } else {
  //   ConstantesTabla.columnasTablaSeleccionCentros.forEach((col) => {
  //     columnas.push(col);
  //   });
  // }

  useEffect(() => {
    if (
      localStorage.getItem("puestosSeleccionados") !== undefined &&
      localStorage.getItem("puestosSeleccionados") !== null
    ) {
      /*setPuestosElegidos(
        JSON.parse(localStorage.getItem("puestosSeleccionados"))
      );*/
    }
    setLoading(true);
  }, []);

  /*const rellenarInputs = (e) => {
    let nomPuesto =
      e.target.parentElement.nextElementSibling.children[0].innerText;
    for (let i = 0; i < puestosElegidos.length; i++) {
      if (nomPuesto.startsWith(puestosElegidos[i].xpt)) {
        puestosElegidos[i].preferencia = parseInt(e.target.value);
      }
    }
  };*/

  const handleClose = (e) => {
    setShow(false);
  };

  useEffect(() => {
    getPuestosSeleccionados(params.idCon, params.idSol).then((data) => {

      setPuestosSeleccionados(data)
    })
  }, [params])

  useEffect(() => {
    if (puestosSeleccionados) {


      // const defaultOrden = puestosSeleccionados.map((row, index) => ({
      //   xpt: row.xpt,
      //   orden: index + 1,
      // }));
      setNuevoOrdenPuestosSeleccionados(puestosSeleccionados);
    }
  }, [puestosSeleccionados]);
  return (
    <>
      <Header></Header>
      {/*<Titulo
        tipo={"tituloPagina"}
        titulo={"Relación de Puestos por Orden de Preferencia"}
      />*/}
      <h2 className="tituloPagina">Relación de Puestos por Orden de Preferencia</h2>

      <div className="containerPuestosOrdenPref" role="main" data-landmark-index="4">
        <div className="mensajeInfo fondo">
          <p>
            <i className="fa-solid fa-caret-right me-3"></i>
            Listado de los puestos que hasta ahora ha seleccionado. Podrá
            realizar una reordenación de ellos, de acuerdo a sus preferencias.
            Utilizando el botón "Reordenar" podrá intercambiar el orden de los
            puestos.
          </p>
        </div>
        <div className={"vistaAnexos"}>
          {loading ? (
            // setIncludeFondo('vistaAnexos fondo')
            <>
              <div className="contTabla mt-5">


                <div className="container tablaPuestos card">
                  <DataTable
                    className="table-responsive"
                    columns={[...ConstantesTabla.columnaTablaPuestosSeleccionado, ...columnas]}
                    data={puestosSeleccionados}
                    pagination
                    paginationComponentOptions={ConstantesTabla.paginacionOpt}
                    noDataComponent={
                      <span>No se encontró ningún puesto seleccionado</span>
                    }
                    customStyles={ConstantesTabla.customStyles}
                    width="auto"
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    onSelectedRowsChange={handleGetOrder}
                    subHeaderWrap={true}
                    style={{ marginTop: "20px" }}
                  />
                </div>
                <div className="d-flex justify-content-between mx-5 row">
                  <div className="col-md-3">
                    <button
                      className="btn py-3 px-5  fw-100"

                      disabled={bloquearReordeno}
                      onClick={(e) => {
                        //TODO: Añadir Endpoint

                        localStorage.removeItem("puestosSeleccionados");

                        reodenarPuestos(params.idCon, params.idSol, nuevoOrdenPuestosSeleccionados).then((data) => {


                          setPuestosSeleccionados(data)
                          const inputs = document.querySelectorAll('input[id^="nuevoOrden"]');

                          // Itera sobre cada input y vacía su valor
                          inputs.forEach(input => {
                            input.value = ''; // Vacía el valor del input
                          });
                        })
                      }}>
                      Reordenar
                    </button>
                  </div>


                  <div className="col-md-3">
                    <button
                      type="button"
                      className="btnRed rounded py-3"
                      onClick={(e) => {
                        //TODO: Añadir Endpoint

                        eliminarPuestos(params.idCon, params.idSol, listaPuestoBorrar).then(() => {

                          getPuestosSeleccionados(params.idCon, params.idSol).then((data) => {
                            setPuestosSeleccionados(data)
                          })

                          /*reodenarPuestos(params.idCon, params.idSol, nuevoOrdenPuestosSeleccionados).then((data) => {
                            
  
                            setPuestosSeleccionados(data)
                            const inputs = document.querySelectorAll('input[id^="nuevoOrden"]');
  
                            // Itera sobre cada input y vacía su valor
                            inputs.forEach(input => {
                              input.value = ''; // Vacía el valor del input
                            });
                          })*/
                        })
                      }}
                    >
                      Borrar Seleccionados
                    </button>
                  </div>
                </div>
                <div className="buttons">
                  {/* <ButtonVolver
                    destino={
                      (params.idcon !== null || params.idcon !== "") &&
                        (params.idsol !== null || params.idsol !== "")
                        ? `consModSolicitudes/${params.idCon}/${params.idSol}`
                        : -1
                    }
                  ></ButtonVolver> */}
                  <div className="col-md-3">
                    <button
                      type="button"
                      className="btnRed rounded botonVolverAnexoII2"
                      onClick={() =>
                        navigate(`/consModSolicitudes/${params.idCon}/${params.idSol}`)
                      }
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>
                  {/* Boton para insertar los puestos recibidos en el location.state */}
                  {/* <Button
                    clases="btn-card"
                    nombre={"Guardar"}
                    funcion={(e) => {
                      //TODO: Añadir Endpoint
                      
                      localStorage.removeItem("puestosSeleccionados");
                      
                      setShow({
                        mensaje: true,
                        content: "Puestos ordenados correctamente",
                        tipo: "tituloModal",
                        destinoCerrar: null,
                      })
                    }}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            //   setIncludeFondo('vistaAnexos')
            <span>
              <SpinnerCircle />
            </span>
          )}
        </div>
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.content}
          tipo={show.tipo}
          //aviso={show.aviso}
          //destinoAviso={show.destinoAviso}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default PuestosOrdenPreferencia;
